// EVENTS.COMPONENTS.APPLICATION.REWARDS.REDEEM.VIEW_REWARD.REWARD_TERMS

export const REWARD_TERMS = {
  TAB_VIEWED: 'terms-tab_viewed'
};
